import React from "react";

import * as Code from "ds/Code";
import useDecodedParams from "Hooks/useDecodedParams";
import { oneDeploymentResourceSelector } from "Reducers/environment/deployment";
import { useCurrentWorker } from "Reducers/environment/hooks/useCurrentWorker";
import useObservabilitySandboxAccess from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilitySandboxAccess";
import Layout from "src/organization/pages/project/environment/services/components/Layout";
import { useGetResourceType } from "src/organization/pages/project/environment/services/overview/components/hooks/useGetResourceType";
import ServiceMetrics from "src/organization/pages/project/environment/services/overview/components/ServiceMetrics";
import ServiceMetrics2 from "src/organization/pages/project/environment/services/overview/components/ServiceMetrics/ServiceMetrics2";
import { useAppSelector } from "Store/hooks";

import SshHostList from "../AppOverview/SshHostList";

import * as S from "./styles";
import { useSshUrl } from "./useSshUrl";
import WorkerInfos from "./WorkerInfos";

type CurrentServiceDecodedParams = {
  environmentId: string;
  organizationId: string;
  projectId: string;
  appName: string;
};

const WorkerOverview = () => {
  const currentWorker = useCurrentWorker();
  const {
    environmentId,
    organizationId,
    projectId,
    appName = "routes"
  } = useDecodedParams<CurrentServiceDecodedParams>();

  const ssh = useSshUrl();
  const canAccessObsSandbox = useObservabilitySandboxAccess();
  const resourceType = useGetResourceType();

  const currentResource = useAppSelector(state =>
    oneDeploymentResourceSelector(state, {
      organizationId,
      projectId,
      environmentId,
      resourceType,
      appName
    })
  );

  return (
    <>
      <Layout>
        <S.WorkerInfoRow>
          {currentWorker && (
            <WorkerInfos
              worker={currentWorker}
              profileLabel={currentResource.profileLabel ?? ""}
            />
          )}
          <S.SshURLList className="ssh-code">
            {ssh && typeof ssh === "string" && (
              <Code.Block singleLine isCopyable id={ssh}>
                {ssh}
              </Code.Block>
            )}
            {ssh instanceof Array && ssh.length > 0 && (
              <SshHostList sshList={ssh} />
            )}
          </S.SshURLList>
        </S.WorkerInfoRow>
      </Layout>
      {canAccessObsSandbox ? (
        <ServiceMetrics2 serviceName={currentWorker.name} />
      ) : (
        <ServiceMetrics name={currentWorker.name} />
      )}
    </>
  );
};

export default WorkerOverview;
